import drag from './drag'

function install(Vue) {
    Vue.directive('drag', drag)
}

export default {
    install
}